import { render, staticRenderFns } from "./plan-view.vue?vue&type=template&id=fb5ef9b6&scoped=true&"
import script from "./plan-view.vue?vue&type=script&lang=js&"
export * from "./plan-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5ef9b6",
  null
  
)

export default component.exports